import { render } from "./LoginLayout.vue?vue&type=template&id=c7524358&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"

import "./login-layout.scss?vue&type=style&index=0&id=c7524358&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7524358"]])

export default __exports__